import AHttpService from '@d-services/a-http-service/a-http-service';
import { addObjectToFormData } from '@d-shared/forms/forms';
import DropdownOptionsHelper from '@d-helpers/dropdown-options-helper';
import URLS from '@d-shared/urls/urls';

class AccountSettingsService extends AHttpService {
  async disableOnboarding() {
    const data = {
      user: {
        profile_attributes: {
          onboard: false,
        },
      },
    };

    const formData = new FormData();
    addObjectToFormData(data, formData);

    const response = await this._http.put(URLS.api.accountSettings.settings, formData);
    return response.data;
  }

  async getAccountSettings() {
    const response = await this._http.get(URLS.api.accountSettings.settings);
    return response.data;
  }

  async getNewBookPeriodicityOptions() {
    const response = await this._http.get(URLS.api.accountSettings.newBookPeriodicity);
    return DropdownOptionsHelper.getListAsOptions(response.data.new_books_periodicities);
  }

  async getNotificationsDigestPeriodicityOptions() {
    const response = await this._http.get(URLS.api.accountSettings.notificationsDigestPeriodicity);
    return DropdownOptionsHelper.getListAsOptions(response.data.notifications_digest_periodicities);
  }

  async saveAccountSettings(data) {
    const formData = new FormData();
    addObjectToFormData(data, formData);

    const response = await this._http.put(URLS.api.accountSettings.settings, formData);
    return response.data;
  }
}

export default new AccountSettingsService();
